module.exports = __webpack_public_path__ + "a6f59c5621e8127bb2a725b01654222d.png";